export const ACCOUNTS_TABLE_BODY_CELL_CLASSNAME = 'h-17 typo-t3 py-lg';
